<template>
  <Preview/>
</template>

<script>
import Preview from './components/preview.vue'

export default {
  name: 'App',
  components: {
    Preview
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
